import MainLayout from '@/common/components/layouts/MainLayout';
import BodyAmountDamageCard from '@/modules/adjusterReportModules/Insurer-information/components/expert/BodyAmountDamageCard';
import BodyExpertEntryTabs from '@/modules/adjusterReportModules/Insurer-information/components/expert/BodyExpertEntryTabs';
import { Box } from 'styled-system/jsx';

export default () => {
  return (
    <MainLayout title="بیمه گذار / کارشناسی" header="titleHeader">
      <BodyExpert />
    </MainLayout>
  );
};
const BodyExpert = () => {
  return (
    <Box pt={24}>
      <BodyAmountDamageCard />
      <BodyExpertEntryTabs />
    </Box>
  );
};
